module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cn":{"qa":"常见问题？","search":"搜索"},"en":{"qa":"Q&A","search":"Search"}}')
  delete Component.options._Ctor
}
